import { jsx as m } from "react/jsx-runtime";
import n from "clsx";
import '../../_assets/IconChip.rgCQhZ6J.css';const p = "_root_1rno0_44", e = {
  root: p
}, _ = ({
  className: o,
  children: t,
  fontColor: r,
  fontSize: s = "12px",
  backgroundColor: c,
  styleOverrides: l
}) => /* @__PURE__ */ m(
  "div",
  {
    className: n(e.root, o),
    style: { color: r, fontSize: s, backgroundColor: c, ...l },
    children: t
  }
);
export {
  _ as IconChip
};
